import { CardTheme } from '@kite-js/theme-types';

const card: CardTheme = {
    borderWidth: '1px',
    borderRadius: 'NONE',
};

export default card;
